import { securedApiRequest } from "./SecuredApi";


/**
 * Fetches the trips associated with a specific user based on their email and role.
 *
 * @async
 * @function fetchUserTrips
 * @param {string} email - The email address of the user whose trips are to be fetched.
 * @param {string} role - The role of the user ('customer' or 'driver').
 * @returns {Promise<Object>} A promise that resolves to the response containing user trips.
 * @throws {Error} Throws an error if the API request fails.
 */
export const fetchUserTrips = async (email, role) => {
    const encodedEmail = encodeURIComponent(email);
    const encodedRole = encodeURIComponent(role);
    return securedApiRequest(`/user-trips/?email=${encodedEmail}&role=${encodedRole}`, "GET");
};


/**
 * Submits a support request by making an asynchronous API call.
 *
 * @param {Object} payload - The data to be sent with the support request.
 * @returns {Promise<Object>} A promise that resolves to the server's response.
 */
export const submitSupportRequest = async (payload) => {
    return securedApiRequest("/support-request/", "POST", payload);
};


/**
 * Asynchronously saves a support message using a secured API request.
 *
 * @function
 * @param {Object} message - The support message that needs to be saved.
 * @returns {Promise<Object>} A promise that resolves to the response from the API after saving the message.
 */
export const saveSupportMessage = async (message) => {
    return securedApiRequest("/save-messages/", "POST", message);
};
